// make a flow object endpoint class dynamically

import FlowObjectViewsetEndpoint from './flow-object-endpoint';

// NOTE - not using this yet, not sure how to add 'extra' endpoints to the class!
// can totally figure it out... but later
const FLOW_OBJECT_ENDPOINT_MAP = {
  // keys are backend model names (resources)
  CustomFlowObjectModel: {
    generalUrl: 'custom-flow-objects/', // viewset URL without the /api/ prefix
  },
  RfxAward: {
    generalUrl: 'rfx-awards/',
  },
  SourcingRequest: {
    generalUrl: 'sourcing-request/',
  },
  QualityIssue: {
    generalUrl: 'quality-issues/',
  },
  Onboarding: {
    generalUrl: 'onboarding/',
  },
  PpapRun: {
    generalUrl: 'ppap-runs/',
  },
  // PerformanceSystem:{  // moved to api-service so we can add extra endpoints
  //   generalUrl: 'performance-systems/',
  // },
  PerformanceDataRun: {
    generalUrl: 'performance-data-runs/',
  },
  VendorScorecardRun: {
    generalUrl: 'vendor-scorecard-runs/',
  },
  // SupplierProjects -- this is a subtype model, so we need it here to set subtype in constructor dynamically
  SupplierProject: {
    generalUrl: 'supplier-projects/',
  },
  // COMPLIANCE THINGS - need them here so we can handle subtypes, since they are all/most subtype models
  ComplianceSubmission: {
    generalUrl: 'comp-sub-flow/',
  },
};

const getCustomFlowObjectEndpoint = (modelClass, flowSubtype) => {
  // console.log(`***   ***   **** HELLO FROM getCustomFlowObjectEndpoint for modelClass ${modelClass} and flowSubtype ${flowSubtype}`);
  const endpointConfig = FLOW_OBJECT_ENDPOINT_MAP[modelClass];
  if (!endpointConfig) {
    throw new Error(`No endpoint config found for model class '${modelClass}'`);
  }
  return new FlowObjectViewsetEndpoint({
    modelClass: modelClass,
    flowSubtype: flowSubtype, // flow subtype slug, IF USED
    generalUrl: endpointConfig.generalUrl,
  });
  // the endpoint instance has a property 'axios' that is the created axios instance -- can use that in extra endpoints
};

export { getCustomFlowObjectEndpoint };
